import { render, staticRenderFns } from "./PaymentGateWayForm.vue?vue&type=template&id=215ecc22&"
import script from "./PaymentGateWayForm.vue?vue&type=script&lang=js&"
export * from "./PaymentGateWayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports